import { z } from 'my-zod'
import { operatorsModel } from '../outfitter'
import { outfitterOrderHeaderSystemView } from './outfitter-order-system-view'

export const outfitterOrderHeaderWmsView = outfitterOrderHeaderSystemView.augment({
  operatorName: operatorsModel.shape.businessName
})

export type outfitterOrderHeaderWmsView = z.infer<typeof outfitterOrderHeaderWmsView>
